export const GET_EXTERNAL_SYSTEMS = 'GET_EXTERNAL_SYSTEMS'
export const GET_EXTERNAL_SYSTEMS_SUCCESS = 'GET_EXTERNAL_SYSTEMS_SUCCESS'
export const GET_EXTERNAL_SYSTEMS_FAILED = 'GET_EXTERNAL_SYSTEMS_FAILED'

export const GET_EXTERNAL_SYSTEM = 'GET_EXTERNAL_SYSTEM'
export const GET_EXTERNAL_SYSTEM_SUCCESS = 'GET_EXTERNAL_SYSTEM_SUCCESS'
export const GET_EXTERNAL_SYSTEM_FAILED = 'GET_EXTERNAL_SYSTEM_FAILED'

export const POST_EXTERNAL_SYSTEM = 'POST_EXTERNAL_SYSTEM'
export const POST_EXTERNAL_SYSTEM_SUCCESS = 'POST_EXTERNAL_SYSTEM_SUCCESS'
export const POST_EXTERNAL_SYSTEM_FAILED = 'POST_EXTERNAL_SYSTEM_FAILED'

export const PUT_EXTERNAL_SYSTEM = 'PUT_EXTERNAL_SYSTEM'
export const PUT_EXTERNAL_SYSTEM_SUCCESS = 'PUT_EXTERNAL_SYSTEM_SUCCESS'
export const PUT_EXTERNAL_SYSTEM_FAILED = 'PUT_EXTERNAL_SYSTEM_FAILED'

export const DELETE_EXTERNAL_SYSTEM = 'DELETE_EXTERNAL_SYSTEM'
export const DELETE_EXTERNAL_SYSTEM_SUCCESS = 'DELETE_EXTERNAL_SYSTEM_SUCCESS'
export const DELETE_EXTERNAL_SYSTEM_FAILED = 'DELETE_EXTERNAL_SYSTEM_FAILED'

export const GET_ENUM_EXTERNAL_SYSTEMS = 'GET_ENUM_EXTERNAL_SYSTEMS'
export const GET_ENUM_EXTERNAL_SYSTEMS_SUCCESS = 'GET_ENUM_EXTERNAL_SYSTEMS_SUCCESS'
export const GET_ENUM_EXTERNAL_SYSTEMS_FAILED = 'GET_ENUM_EXTERNAL_SYSTEMS_FAILED'
